/**
 * Created by Karol Kluska on 27.06.17.
 */

angular
  .module('app')
  .factory('ParamsValidator', ParamsValidator);

function ParamsValidator() {
  function isValidUserHash(userHash) {
    // var isString = angular.isString(userHash);
    // if (!isString || userHash.length !== 32) {
    //   return false;
    // }
    var patternMd5Hash = /^([0-9]{1,32})/g;

    return patternMd5Hash.test(userHash);
  }

  function isValidHotelId(hotelId) {
    hotelId = parseInt(hotelId, 10);

    return !isNaN(hotelId) && hotelId >= 0;
  }

  function isValidLanguage(language, availableLanguages) {
    if (!angular.isString(language) || language.length !== 2) {
      return false;
    }

    if (isValidAvailableLanguages(availableLanguages)) {
      return availableLanguages.indexOf(language) !== -1;
    }

    return true;
  }

  function isValidAvailableLanguages(languages) {
    return angular.isArray(languages);
  }

  function isValidCategoryId(categoryId) {
    return categoryId > 0;
  }

  function isValidRoomGroupId(roomGroupId) {
    return roomGroupId > 0;
  }

  function isValidRateplanId(rateplanId) {
    return rateplanId > 0;
  }

  function isValidCheckIn(checkIn, time) {
    var isValid = moment(checkIn, 'YYYY-MM-DD', true).isValid();
    if (!isValid) {
      return false;
    }
    var today = moment().startOf('day');

    if (moment(checkIn).isSameOrAfter(today, 'day')) {
      if (isValidTime(time)) {
        if (moment(checkIn).isSame(today, 'day')) {
          var now = moment();
          var hourAndMinutes = time.split(':');
          var hour = parseInt(hourAndMinutes[0], 10);
          var minutes = parseInt(hourAndMinutes[1], 10);
          today.hour(hour).minute(minutes);
          return moment(now).isBefore(today, 'minutes');
        }
      }
      return true;
    }
    return false;
  }

  function isValidTime(time) {
    if (!angular.isString(time)) {
      return false;
    }

    var hourAndMinutes = time.split(':');
    if (hourAndMinutes.length !== 2) {
      return false;
    }
    var hour = parseInt(hourAndMinutes[0], 10);
    var minutes = parseInt(hourAndMinutes[1], 10);

    if (isNaN(hour) || !angular.isNumber(hour) || isNaN(minutes) || !angular.isNumber(minutes)) {
      return false;
    }

    return hour >= 0 && hour < 24 && minutes >= 0 && minutes < 60;
  }

  function isValidCheckOut(checkIn, checkOut) {
    var isValid = moment(checkOut, 'YYYY-MM-DD', true).isValid();
    if (!isValid) {
      return false;
    }

    return moment(checkOut).isAfter(checkIn, 'day');
  }

  function isValidOccupancy(occupancy) {
    try {
      occupancy = angular.fromJson(decodeURIComponent(occupancy));
    } catch (e) {
      return false;
    }

    if (!angular.isArray(occupancy) || occupancy.length === 0) {
      return false;
    }

    for (var i = 0; i < occupancy.length; i++) {
      if (isNaN(occupancy[i].count) || occupancy[i].count < 1 || occupancy[i].count > 50) {
        return false;
      }

      if (!angular.isArray(occupancy[i].categoryCount)) {
        return false;
      }

      for (var j = 0; j < occupancy[i].categoryCount.length; j++) {
        if (occupancy[i].categoryCount[j] < 0 || occupancy[i].categoryCount[j] > 50) {
          return false;
        }
      }
    }
    return true;
  }

  function isValidCart(cart) {
    try {
      cart = angular.fromJson(decodeURIComponent(cart));
    } catch (e) {
      return false;
    }

    if (!angular.isArray(cart) || cart.length === 0) {
      return false;
    }

    for (var i = 0; i < cart.length; i++) {
      var item = cart[i];
      if (!angular.isObject(item)) {
        return false;
      }
      if (isNaN(item.persons) || isNaN(item.roomId) || isNaN(item.rateplanId)) {
        return false;
      }
    }
    return true;
  }

  function isValidDiscountCode(code) {
    if (!angular.isString(code)) {
      return false;
    }

    return code.length > 0;
  }

  function isValidPaymentToken(token) {
    if (!angular.isString(token)) {
      return false;
    }
    return token.length >= 36;
  }

  function validateBinary7Digits(value) {
    return /^[01]{7}$/.test(value);
  }

  return {
    isValidUserHash: isValidUserHash,
    isValidHotelId: isValidHotelId,
    isValidLanguage: isValidLanguage,
    isValidCategoryId: isValidCategoryId,
    isValidRoomGroupId: isValidRoomGroupId,
    isValidRateplanId: isValidRateplanId,
    isValidCheckIn: isValidCheckIn,
    isValidCheckOut: isValidCheckOut,
    isValidOccupancy: isValidOccupancy,
    isValidCart: isValidCart,
    isValidDiscountCode: isValidDiscountCode,
    isValidPaymentToken: isValidPaymentToken,
    validateBinary7Digits: validateBinary7Digits
  };
}
